/**
 * @generated SignedSource<<1d57fb3c8dfb487067b223b3b1844457>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type src_issueViewLayoutTemplatesLayoutItem_LayoutItemInternal$data = {
  readonly __typename: string;
  readonly fieldId: string;
  readonly type: string;
  readonly " $fragmentSpreads": FragmentRefs<"relayLayoutItems_issueViewLayoutTemplatesLayoutItem_RelayLayoutItemFragmentContainer">;
  readonly " $fragmentType": "src_issueViewLayoutTemplatesLayoutItem_LayoutItemInternal";
};
export type src_issueViewLayoutTemplatesLayoutItem_LayoutItemInternal$key = {
  readonly " $data"?: src_issueViewLayoutTemplatesLayoutItem_LayoutItemInternal$data;
  readonly " $fragmentSpreads": FragmentRefs<"src_issueViewLayoutTemplatesLayoutItem_LayoutItemInternal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "issueViewRelayAssigneeFieldFlag"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "issueViewRelayDateFieldFlag"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "issueViewRelayDateTimeFieldFlag"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "issueViewRelayNumberFieldFlag"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "issueViewRelayPeopleAndApproversFieldFlag"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "issueViewRelayPriorityFieldFlag"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "issueViewRelayProjectFieldFlag"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "issueViewRelaySingleLineTextFieldFlag"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "issueViewRelaySprintFieldFlag"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "issueViewRelayUrlFieldFlag"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "jcsIssueLayoutEapFlag"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "jsmSentimentCustomFieldFlag"
    }
  ],
  "kind": "Fragment",
  "name": "src_issueViewLayoutTemplatesLayoutItem_LayoutItemInternal",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "issueViewRelayAssigneeFieldFlag",
          "variableName": "issueViewRelayAssigneeFieldFlag"
        },
        {
          "kind": "Variable",
          "name": "issueViewRelayDateFieldFlag",
          "variableName": "issueViewRelayDateFieldFlag"
        },
        {
          "kind": "Variable",
          "name": "issueViewRelayDateTimeFieldFlag",
          "variableName": "issueViewRelayDateTimeFieldFlag"
        },
        {
          "kind": "Variable",
          "name": "issueViewRelayNumberFieldFlag",
          "variableName": "issueViewRelayNumberFieldFlag"
        },
        {
          "kind": "Variable",
          "name": "issueViewRelayPeopleAndApproversFieldFlag",
          "variableName": "issueViewRelayPeopleAndApproversFieldFlag"
        },
        {
          "kind": "Variable",
          "name": "issueViewRelayPriorityFieldFlag",
          "variableName": "issueViewRelayPriorityFieldFlag"
        },
        {
          "kind": "Variable",
          "name": "issueViewRelayProjectFieldFlag",
          "variableName": "issueViewRelayProjectFieldFlag"
        },
        {
          "kind": "Variable",
          "name": "issueViewRelaySingleLineTextFieldFlag",
          "variableName": "issueViewRelaySingleLineTextFieldFlag"
        },
        {
          "kind": "Variable",
          "name": "issueViewRelaySprintFieldFlag",
          "variableName": "issueViewRelaySprintFieldFlag"
        },
        {
          "kind": "Variable",
          "name": "issueViewRelayUrlFieldFlag",
          "variableName": "issueViewRelayUrlFieldFlag"
        },
        {
          "kind": "Variable",
          "name": "jcsIssueLayoutEapFlag",
          "variableName": "jcsIssueLayoutEapFlag"
        },
        {
          "kind": "Variable",
          "name": "jsmSentimentCustomFieldFlag",
          "variableName": "jsmSentimentCustomFieldFlag"
        }
      ],
      "kind": "FragmentSpread",
      "name": "relayLayoutItems_issueViewLayoutTemplatesLayoutItem_RelayLayoutItemFragmentContainer"
    }
  ],
  "type": "JiraIssueField",
  "abstractKey": "__isJiraIssueField"
};

(node as any).hash = "fab313df48673a1a08dc71bf1b9d3bd9";

export default node;
